import { useState, useEffect } from 'react';
import { cambios, conductores } from '../services/api';

const RefreshCw = () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
);

const FilterIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
    </svg>
);

export default function CambiosHistorialAdmin() {
    const [historial, setHistorial] = useState([]);
    const [loading, setLoading] = useState(true);
    const [conductoresList, setConductoresList] = useState([]);

    // Filters
    const [filters, setFilters] = useState({
        conductorId: '',
        desde: '',
        hasta: ''
    });

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        loadHistorial();
    }, [filters]);

    const loadInitialData = async () => {
        try {
            const drivers = await conductores.getAll(true);
            setConductoresList(drivers);
        } catch (error) {
            console.error('Error loading initial data:', error);
        }
    };

    const loadHistorial = async () => {
        setLoading(true);
        try {
            const data = await cambios.getHistorial(filters);
            setHistorial(data);
        } catch (error) {
            console.error('Error loading historial:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const clearFilters = () => {
        setFilters({ conductorId: '', desde: '', hasta: '' });
    };

    return (
        <div>
            <div className="flex items-center gap-3 mb-8">
                <div className="p-3 bg-blue-500/10 rounded-xl">
                    <RefreshCw />
                </div>
                <div>
                    <h1 className="text-2xl font-bold text-white">Historial de Cambios</h1>
                    <p className="text-gray-400">Registro completo de intercambios de días</p>
                </div>
            </div>

            {/* Filters */}
            <div className="bg-slate-800/50 p-4 rounded-xl border border-slate-700 mb-6">
                <div className="flex items-center gap-2 mb-4 text-blue-400 font-medium">
                    <FilterIcon /> Filtros
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-xs text-gray-400 mb-1">Conductor</label>
                        <select
                            name="conductorId"
                            value={filters.conductorId}
                            onChange={handleFilterChange}
                            className="w-full bg-slate-900 border border-slate-700 text-white rounded-lg px-3 py-2 text-sm focus:border-blue-500 outline-none"
                        >
                            <option value="">Todos</option>
                            {conductoresList.map(c => (
                                <option key={c.id} value={c.id}>{c.nombre} {c.apellidos}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-xs text-gray-400 mb-1">Desde</label>
                        <input
                            type="date"
                            name="desde"
                            value={filters.desde}
                            onChange={handleFilterChange}
                            className="w-full bg-slate-900 border border-slate-700 text-white rounded-lg px-3 py-2 text-sm focus:border-blue-500 outline-none"
                        />
                    </div>
                    <div>
                        <label className="block text-xs text-gray-400 mb-1">Hasta</label>
                        <input
                            type="date"
                            name="hasta"
                            value={filters.hasta}
                            onChange={handleFilterChange}
                            className="w-full bg-slate-900 border border-slate-700 text-white rounded-lg px-3 py-2 text-sm focus:border-blue-500 outline-none"
                        />
                    </div>
                    <div className="flex items-end">
                        <button
                            onClick={clearFilters}
                            className="w-full bg-slate-700 hover:bg-slate-600 text-white py-2 rounded-lg text-sm transition-colors"
                        >
                            Limpiar Filtros
                        </button>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="bg-slate-800 rounded-xl border border-slate-700 overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full text-left">
                        <thead>
                            <tr className="bg-slate-900/50 border-b border-slate-700 text-gray-400 text-xs uppercase">
                                <th className="px-6 py-4 font-semibold">Fecha Cambio</th>
                                <th className="px-6 py-4 font-semibold">Solicitante</th>
                                <th className="px-6 py-4 font-semibold">Día Necesitado</th>
                                <th className="px-6 py-4 font-semibold">Respondedor</th>
                                <th className="px-6 py-4 font-semibold">Día Ofrecido</th>
                                <th className="px-6 py-4 font-semibold">Estado</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-700">
                            {loading ? (
                                <tr>
                                    <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                                        Cargando historial...
                                    </td>
                                </tr>
                            ) : historial.length === 0 ? (
                                <tr>
                                    <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                                        No se encontraron registros
                                    </td>
                                </tr>
                            ) : (
                                historial.map((row) => {
                                    // Safe date formatting function
                                    const formatDate = (dateValue) => {
                                        if (!dateValue) return '-';
                                        try {
                                            // Handle both YYYY-MM-DD and YYYY-MM-DD HH:MM:SS formats
                                            const dateStr = String(dateValue).split(' ')[0].split('T')[0];
                                            const [year, month, day] = dateStr.split('-').map(Number);
                                            if (!year || !month || !day) return '-';
                                            const date = new Date(year, month - 1, day);
                                            return date.toLocaleDateString('es-ES');
                                        } catch {
                                            return '-';
                                        }
                                    };

                                    return (
                                        <tr key={row.id} className="hover:bg-slate-700/30 transition-colors">
                                            <td className="px-6 py-4 text-sm text-gray-400">
                                                {formatDate(row.fecha_intercambio)}
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="text-white font-medium">{row.conductor_origen_nombre || '-'}</span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="text-emerald-400">
                                                    {formatDate(row.dia_origen)} ({row.turno_origen || '-'})
                                                </span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="text-white font-medium">{row.conductor_destino_nombre || '-'}</span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="text-purple-400">
                                                    {formatDate(row.dia_destino)} ({row.turno_destino || '-'})
                                                </span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <span className="bg-green-500/10 text-green-400 px-2 py-1 rounded-full text-xs font-semibold border border-green-500/20">
                                                    COMPLETADO
                                                </span>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
